// Task #3040 — Logica condivisa di selezione servizio/prodotto collegato.
//
// Estratta da `useAppointmentForm` (form pubblico) per essere riusata identica
// nel modale "Nuovo Appuntamento" (sezione Completo) lato admin. Le regole
// dipendono dalla modalità configurata sul form pubblico
// (`serviceSelectionMode`); il modale admin non ha configurazione propria e usa
// sempre la modalità 'auto'.

export type ServiceSelectionMode = 'auto' | 'always' | 'required' | 'never';

interface LinkedProductLike {
  id: string;
}

/**
 * True se va mostrato il selettore inline del prodotto collegato.
 * - 'never'            → mai
 * - 'auto'             → solo con PIÙ prodotti (con uno solo si auto-seleziona)
 * - 'always'/'required'→ sempre, se la tipologia ha almeno un prodotto
 */
export function shouldShowProductPicker(
  mode: ServiceSelectionMode,
  products: readonly LinkedProductLike[] | null | undefined,
): boolean {
  const list = products ?? [];
  if (mode === 'never') return false;
  if (list.length === 0) return false;
  if (mode === 'auto') return list.length > 1;
  return true;
}

/**
 * True se la modalità impone una scelta esplicita del prodotto (blocca il
 * salvataggio/avanzamento finché non è selezionato).
 */
export function isServiceProductRequired(
  mode: ServiceSelectionMode,
  products: readonly LinkedProductLike[] | null | undefined,
): boolean {
  if (mode !== 'required') return false;
  return (products ?? []).length > 0;
}

/**
 * In modalità 'auto' con un solo prodotto collegato, restituisce l'id da
 * auto-selezionare (il selettore non viene mostrato). Altrimenti `null`.
 */
export function autoSelectSingleProduct(
  mode: ServiceSelectionMode,
  products: readonly LinkedProductLike[] | null | undefined,
): string | null {
  const list = products ?? [];
  if (mode === 'auto' && list.length === 1) return list[0]!.id;
  return null;
}
